module.exports = __webpack_public_path__ + "static/media/25.d1180db5.png";